import { Link } from 'react-router-dom'
import { useAuth, myRoleLabels } from '../core/auth'
import { MODULES } from '../core/modules'
import { Empty } from '../ui/States'
import { useNorseTerm } from '../modules/norseterm/NorseTermData'
import { TermBanner, NextUp } from '../modules/norseterm/TermBanner'

/**
 * The home screen IS the navigation, and it is a pure function of the signed-in
 * person's grants. Nobody is trained on which tiles to ignore, and nobody has
 * to pick a building before saying what they want to do.
 */
export function Home() {
  const a = useAuth()
  const { profile, displayName, canUseTool } = a
  const mine = MODULES.filter((m) => canUseTool(m.id))
  const nt = useNorseTerm()

  return (
    <>
      <div className="home__greet">
        <h1 className="page-title">{greeting()}, {displayName.split(' ')[0] || 'there'}.</h1>
        <p className="page-sub">{new Date().toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' })}</p>
      </div>

      {/* Norse Term is where the work is right now: its dates and the next
          step come first, the tool tiles after. */}
      {nt.enabled && !nt.loading && <><TermBanner /><NextUp /></>}

      {/* An account still on the old `grants` shape reads as "nothing assigned",
          which is indistinguishable from a real permissions problem and sent
          somebody down a blind alley for an afternoon. Say what it actually is. */}
      {profile && !Array.isArray(profile.caps) && !profile.districtAdmin && (
        <div className="notice notice--warning">
          <span aria-hidden="true">⚠</span>
          <div>
            <strong>This account is on the old permissions format.</strong> Your record has
            no capability list, so no tools can be turned on for you. Whoever set the app up
            needs to run <code>npm install &amp;&amp; npm run seed:dev</code> once. Nothing
            is wrong with your account itself.
          </div>
        </div>
      )}

      {mine.length === 0 ? (
        <Empty
          title="Nothing assigned yet"
          body="Your account works, but no tools have been turned on for you. Your building admin can add them."
        />
      ) : (
        <>
        {nt.enabled && <h2 className="home__tools">Your tools</h2>}
        <div className="tiles">
          {mine.map((m) =>
            m.enabled ? (
              <Link key={m.id} to={m.path} className="tile">
                <m.icon className="tile__icon" size={22} strokeWidth={1.75} aria-hidden="true" />
                <div className="tile__title">{m.title} {m.Badge && <m.Badge />}</div>
                <div className="tile__blurb">{m.blurb}</div>
                {myRoleLabels(a, m.id).length > 0 && (
                  <div className="tile__role">You: {myRoleLabels(a, m.id).join(', ')}</div>
                )}
              </Link>
            ) : (
              <button key={m.id} className="tile" disabled>
                <m.icon className="tile__icon" size={22} strokeWidth={1.75} aria-hidden="true" />
                <div className="tile__title">{m.title}</div>
                <div className="tile__blurb">Coming soon</div>
              </button>
            ),
          )}
        </div>
        </>
      )}
    </>
  )
}

function greeting(): string {
  const h = new Date().getHours()
  if (h < 12) return 'Good morning'
  if (h < 17) return 'Good afternoon'
  return 'Good evening'
}
